export class CsrfFetchInterceptor
{
    static install()
    {
        if (window.__csrfFetchInterceptor) {
            return;
        }

        window.__csrfFetchInterceptor = true;

        const originalFetch = window.fetch.bind(window);
        window.fetch = function (resource, init) {
            init = init || {};
            const url = typeof resource === 'string'
                ? resource
                : (resource && resource.url) || '';
            const isAbsolute = /^https?:\/\//.test(url);
            const sameOrigin = !isAbsolute || url.startsWith(window.location.origin);
            const method = ((init.method || (resource && resource.method) || 'GET')).toUpperCase();
            const needsToken = method !== 'GET' && method !== 'HEAD' && method !== 'OPTIONS';

            if (sameOrigin && needsToken) {
                const headers = new Headers(init.headers || {});
                if (!headers.has('X-CSRF-TOKEN')) {
                    const meta = document.querySelector('meta[name="csrf-token"]');
                    if (meta && meta.content) {
                        headers.set('X-CSRF-TOKEN', meta.content);
                    }
                }
                init.headers = headers;
            }
            return originalFetch(resource, init);
        }
    }
}